import React, { useState, useCallback, useContext } from "react";
import { useSelector } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";

import { api } from "../../../../Services/Api";
import Loading from "../../../Loading";
import { Container, ContainerTooltip } from "./styles";
import { AnswersContext } from "./../../index";

function ListPrevAnswers({ onAdd, onClose, answersList }) {
  const { product } = useContext(AnswersContext);

  const handleClick = (answer) => () => {
    onAdd(answer);
    onClose();
  };

  if (!answersList) return <Loading />;

  return (
    <Container>
      {answersList.map((answer) => (
        <>
          <Tooltip
            arrow
            placement="left"
            title={
              <ContainerTooltip>
                <p>
                  <strong>Opções:</strong>
                </p>
                <ul>
                  {answer.itens.slice(0, 5).map((item) => (
                    <li>
                      <span>{item.printDescription}</span>
                      <span>
                        {item.price.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                    </li>
                  ))}
                  {answer.itens.length > 5 && (
                    <li>
                      . . . <i>mais {answer.itens.slice(5).length} itens</i>
                    </li>
                  )}
                </ul>
              </ContainerTooltip>
            }
          >
            <div onClick={handleClick(answer)}>{answer.nameShow}</div>
          </Tooltip>
        </>
      ))}
    </Container>
  );
}

export default ListPrevAnswers;
